import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

export default function InceptionDateInfo({ fund }) {
  const d = moment(_.get(fund, 'inceptionDate'));
  const diff = moment().diff(d, 'years');
  return (
    <>
      {`${d.format('D MMM YYYY')}`}
      {!!diff && <small>{`(${diff}+ year${diff > 1 ? 's' : ''})`}</small>}
    </>
  );
}

InceptionDateInfo.propTypes = {
  fund: PropTypes.shape({
    inceptionDate: PropTypes.string,
  }).isRequired,
};
